import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-training-certificate',
  templateUrl: './training-certificate.component.html',
  styleUrls: ['./training-certificate.component.css']
})
export class TrainingCertificateComponent implements OnInit {
  title="Training certificate";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/training-details/training-certificate/training-certificate.component.ts